/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Container, Box, Grid } from "@material-ui/core";
import styles from "./styles.module.scss";
import Loading from "../../../../../home/components/Loading";
import InputForm from "../../../../../../components/InputForm";
import FormActions from "../../../../components/FormActions";
import { AppAPIService } from "../../../../../../services/AppAPIService";
import Swal from "sweetalert2";
import store from "../../../../../../store/store";

export const AutomaticResponseForm = (props) => {
  const labels = ["Título *", "Mensagem *"];
  let api = AppAPIService.getInstance();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const { auth } = store.getState();

  /*name*/
  const [title, setTitle] = useState("");
  const [titleRole, setTitleRole] = useState("");
  const [titleError, setTitleError] = useState("");
  const handleInputTitle = (title) => {
    if (!title) {
      setTitle();
      setTitleError("Campo obrigatório");
      setTitleRole("notOk");
    } else {
      setTitle(title);
      setTitleError("");
      setTitleRole("ok");
    }
  };
  /* end name*/

  /* message type */
  const [message, setMessage] = useState("");
  const [messageError, setMessageError] = useState("");
  const [messageRole, setMessageRole] = useState("");

  const handleInputMessage = (message) => {
    if (!message) {
      setMessage();
      setMessageError("Campo obrigatório");
      setMessageRole("notOk");
    } else {
      setMessage(message);
      setMessageError("");
      setMessageRole("ok");
    }
  };
  /* end message type */

  const formIsValid = useCallback(() => {
    let validForm = true;

    validForm =
      title !== "" &&
      titleRole === "ok" &&
      messageRole === "ok" &&
      message !== "";
    return validForm;
  }, [title, titleRole, message, messageRole]);

  /* end form validation */
  /* submitCreation */
  const submitCreation = useCallback(
    async (e) => {
      setIsLoading(true);
      e.preventDefault();
      try {
        setIsLoading(true);
        const response = await api.makeHttpRequest({
          url: `/automatic-message`,
          method: "POST",
          data: {
            title,
            message,
          },
        });
        setIsLoading(false);
        Swal.fire({
          icon: "success",
          title: "Sucesso!",
          text: `Resposta criada com sucesso`,
        }).then(() => {
          history.push("/admin/parametrizacao");
        });
      } catch (error) {
        console.error("error: ", error);
        setIsLoading(false);
      } finally {
        setIsLoading(false);
      }
    },
    [
      history,
      api,
      auth.token,
      auth.user,
      title,
      message,
      setIsLoading,
      setTitleError,
      setTitleRole,
    ]
  );
  /* end submitCreation */

  /* submitEdition */
  const submitEdition = useCallback(
    async (e) => {
      setIsLoading(true);
      e.preventDefault();
      try {
        const response = await api.makeHttpRequest({
          url: `/automatic-message`,
          method: "PATCH",
          data: {
            id:
              typeof props.editingRecord.id === "number"
                ? props.editingRecord.id
                : parseInt(props.editingRecord.id),
            title,
            message,
          },
        });
        setIsLoading(false);
        Swal.fire({
          icon: "success",
          title: "Sucesso!",
          text: `Resposta atualizada com sucesso.`,
        }).then(() => {
          history.push("/admin/parametrizacao");
        });
      } catch (error) {
        setIsLoading(false);
      } finally {
        setIsLoading(false);
      }
    },
    [
      history,
      api,
      auth.token,
      auth.user,
      title,
      message,
      setIsLoading,
      setTitleError,
      setTitleRole,
    ]
  );

  /* clean form */
  const onCleanForm = async () => {
    setTitle("");
    setMessage("");
    setTitleError("");
    setTitleRole("");
    setMessageError("");
    setMessageRole("");
  };
  useEffect(() => {
    if (props?.editingRecord) {
      const { editingRecord } = props;
      handleInputMessage(editingRecord.message);
      handleInputTitle(editingRecord.title);
    }
  }, [props?.editingRecord]);

  /* end clean form */
  return (
    <Container
      style={{
        display: "block",
        margin: "0",
        padding: "0",
      }}
      maxWidth="xl"
    >
      <Loading isLoading={isLoading} />
      <Container
        style={{
          width: "100%",
          display: "block",
          padding: 0,
          margin: "0 !important",
        }}
        maxWidth="xl"
      >
        <form
          className={styles.form}
          autoComplete="off"
          style={{
            padding: "0 !important",
            margin: "0 !important",
          }}
        >
          <div
            className={styles.containerInputs}
            style={{
              padding: "0 !important",
            }}
          >
            <Grid xl={12} lg={12} md={12} sm={12} xs={12} container style={{}}>
              <Grid
                sm={4}
                xl={4}
                lg={4}
                md={4}
                style={{
                  padding: "0 5px 0 0 ",
                }}
              >
                <InputForm
                  type="text"
                  name="title"
                  placeholder="Digite o título da resposta"
                  style={{}}
                  label={labels[0]}
                  value={title}
                  required={true}
                  onChange={handleInputTitle}
                  error={titleError}
                  role={titleRole}
                  withoutTextTransform
                />
              </Grid>
              <Grid
                sm={8}
                xl={8}
                lg={8}
                md={8}
                style={{
                  padding: "0 5px 0 0 ",
                }}
              >
                <InputForm
                  type="text"
                  name="message"
                  placeholder="Insira a mensagem que será utilizada"
                  label={labels[1]}
                  required={true}
                  value={message}
                  onChange={handleInputMessage}
                  error={messageError}
                  role={messageRole}
                  withoutTextTransform
                />
              </Grid>
            </Grid>
          </div>
        </form>
      </Container>
      <FormActions
        module={"parametrizacao"}
        formIsValid={formIsValid()}
        onCleanForm={onCleanForm}
        onSubmit={props?.editingRecord ? submitEdition : submitCreation}
        hideCancel={true}
        messagem
      />
    </Container>
  );
};
export default AutomaticResponseForm;
